<button
  (click)="change.emit(flagged)"
  class="cg-button-appearance-none"
  [attr.aria-label]="
    disabled ? 'Flagging disabled' : flagged ? removeText : addText
  "
>
  <cigna-icon
    class="flag cg-clickable-icon"
    [class.disabled]="disabled"
    [class.flag-icon-small]="size === 'small'"
    [class.flag-icon-medium]="size === 'medium'"
    [class.active]="flagged"
    [title]="disabled ? '' : flagged ? removeText : addText"
    [type]="flagged ? 'flag-solid' : 'flag'"
  >
  </cigna-icon>
</button>
